import TWalkthroughInviteUser from './index.vue';

TWalkthroughInviteUser.install = app => {
  app.component(TWalkthroughInviteUser.name, TWalkthroughInviteUser);
};

export default TWalkthroughInviteUser;
